module.exports = __webpack_public_path__ + "static/media/qq.0086370b.svg";